module.exports = __webpack_public_path__ + "img/logo3.b2037a59.png";